import { useState } from 'react';

type EntityModalType = 'company' | 'site' | 'unit' | 'personnel';

interface EntityModalState {
  type: EntityModalType | null;
  id?: string;
  siteId?: string;
  unitIndex?: number;
  personnelFocus?: 'alarmContact';
}

export function useEntityModal() {
  const [modal, setModal] = useState<EntityModalState>({ type: null });

  const openCompanyModal = (companyId: string) => setModal({ type: 'company', id: companyId });

  const openSiteModal = (siteId: string) => setModal({ type: 'site', id: siteId });

  const openUnitModal = (siteId: string, unitId: string, unitIndex?: number) =>
    setModal({ type: 'unit', id: unitId, siteId, unitIndex });

  const openPersonnelModal = (companyId: string, options?: { focusAlarmContact?: boolean }) =>
    setModal({
      type: 'personnel',
      id: companyId,
      personnelFocus: options?.focusAlarmContact ? 'alarmContact' : undefined,
    });

  const closeModal = () => setModal({ type: null });

  return {
    modal,
    openCompanyModal,
    openSiteModal,
    openUnitModal,
    openPersonnelModal,
    closeModal,
  };
}
